<template>
  <div class="SliderWidget">
    <div class="bg" :style="bgStyle">
      <div class="container">
        <div class="contentWrapper">
          <div class="content" v-html="conf.content" :style="contentStyle"></div>
          <div class="ctaWrapper">
            <a :href="conf.ctaHref" class="cta" v-html="conf.ctaText" target="_blank"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import '@images/footer_03.svg'

  export default {
    name: 'SliderWidget',
    props: {
      conf: {
        type: Object,
        default: ()=>{
          return {
            content: "Milano riparte dai quartieri",
            ctaText: "Partecipa al bando",
            ctaHref: "#",
            target: "_blank",
            bgImage: null,
            bgColor: null,
            textColor: null
          }
        }
      }
    },
    computed: {
      bgStyle(){
        return {
          backgroundColor: !!this.conf.bgColor ? this.conf.bgColor : '#4B4077',
          backgroundImage: !!this.conf.bgImage ? `url(${this.conf.bgImage})`: null
        }
      },
      contentStyle(){
        return { 
          color: !!this.conf.textColor ? this.conf.textColor : '#fff'
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '~@less/_variables';
  @import '~@less/common';

  .SliderWidget{
    .bg{
      min-height: 440px;
      padding: 6.25em 0 0;
      background-size: 50%;
      background-repeat: no-repeat;
      background-position-y: 97%;
      background-position-x: 94%;
      @media (min-width: @bootstrap-md){
        background-size: 220px;
        background-repeat: no-repeat;
        background-position-y: 90%;
        background-position-x: 95%;
        padding: 6.25em 0;
      }
      @media (min-width: @bootstrap-lg){
        min-height: 500px;
        background-size: 400px;
        background-repeat: no-repeat;
        background-position-y: calc(100% - 15px);
        background-position-x: calc(100% - 10px);
      }
    }

    /deep/ .content h1{
      font-size: 2em;
      line-height: 1.25;
      margin-bottom: 0;
      @media (min-width: @bootstrap-md){
        font-size: 3.525em;
      }
      @media (min-width: @bootstrap-lg){
        font-size: 5.125em;
      }
    }

    /deep/ .content h2{
      font-size: 1.425em;
      line-height: 1.25;
      margin-bottom: 0;
      @media (min-width: @bootstrap-md){
        font-size: 2.125em;
      }
      @media (min-width: @bootstrap-lg){
        font-size: 3.25em;
      }
    }

    /deep/ .content p{
      font-size: 1.125em;
      line-height: 1.25;
      margin-bottom: 0;
      @media (min-width: @bootstrap-md){
        font-size: 1.825em;
      }
      @media (min-width: @bootstrap-lg){
        font-size: 2.5em;
      }
    }

    .cta{
      display: inline-block;
      background-color: var(--special-network-color);
      font-size: 1.125em;
      margin-top: 2.665em;
      font-weight: @bold;
      line-height: 2.5em;
      padding: 0 0.5em;
      &:link, &:visited, &:hover, &:active{
        color: #fff;
        text-decoration: none;
      }
      @media (min-width: @bootstrap-md){
        padding: 0 2.444em;
        line-height: 3.333em;
      }
    }
  }

</style>
